import React, { useState, useEffect, useRef } from 'react';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import { useManagePostRequest } from '../../hooks/useManagePostRequest/useManagePostRequest';
import { useManagePutRequest } from '../../hooks/useManagePutRequest/useManagePutRequest';
import ModalForm from '../../components/modalComponents/ModalForm';
import InputText from '../../components/modalComponents/InputText';
import InputSelect from '../../components/modalComponents/InputSelect';
import { getTiposDocumentoAPI, createPostulanteAPI, updatePostulanteAPI, 
         getTiposCargoAPI, getCargosByTipoAPI, getNivelesEducativosAPI, getEspecialidadesAPI,
         buscarPostulantePorDocumentoAPI } from '../../consumers/backendApisUrls';
import { responseCode200 } from '../../consumers/httpRequiestsUtils';
import { toast } from 'react-toastify';
import ReactDOM from "react-dom";

const ModalMensajePostulanteActivo = ({
  showModal, 
  setShowModal,
  mensaje
}) => {

  const [isProcessing, setIsProcessing] = useState(false);

  const handleCloseModal = () => {
      setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <>
        {showModal && ReactDOM.createPortal(
            <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-danger text-white">
                            <h5 className="modal-title">
                                <i className="fas fa-exclamation-triangle mr-2"></i>Registro de Postulante
                            </h5>
                            <button type="button" className="close text-white" onClick={handleCloseModal}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body text-center py-4">
                            <p className="mb-2" style={{ whiteSpace: 'pre-line', lineHeight: '1.5' }}>{mensaje}</p>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleCloseModal}
                                disabled={isProcessing}
                            >
                                Aceptar
                            </button>
                        </div>
                    </div>
                </div>
            </div>,
            document.body
        )}
    </>
  );
};

export default ModalMensajePostulanteActivo;